/* eslint-disable comma-dangle */
export default {
  "__schema": {
    "types": [
      {
        "kind": "UNION",
        "name": "Altinn3SubmissionTypePolymorphicParent",
        "possibleTypes": [
          {
            "name": "Amelding"
          },
          {
            "name": "AmeldingReconciliationReport"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "AltinnSubmissionTypePolymorphicParent",
        "possibleTypes": [
          {
            "name": "Amelding"
          },
          {
            "name": "AmeldingReconciliationReport"
          }
        ]
      }
    ]
  }
};
